import Confirm from './ConfirmInstance';
import LocaleReceiver from '../locale-provider/LocaleReceiver';

export default LocaleReceiver('Confirm')(Confirm);
